export function formatMoney(value, currency) {
  const amount = Number(value || 0);
  const fixed = amount.toFixed(2);
  const [euros, cents] = fixed.split(".");
  const grouped = euros.replace(/\B(?=(\d{3})+(?!\d))/g, currency.delimiter);

  return `${grouped}${currency.separator}${cents} ${currency.unit}`;
}
/**
 * @param {string|number} amount
 * @param {{ unit: string; separator: string; delimiter: string }} currency
 */
